import { useQuery, type UseQueryResult } from "@tanstack/react-query"
import type { Appointment } from "fhir/r3"
import { SimplifiedAppointment } from "../appointment.types"

type FetchAppointmentParams = {
  appointmentId?: string
  token?: string | null
}

export async function fetchAppointment({
  appointmentId,
  token,
}: FetchAppointmentParams): Promise<SimplifiedAppointment> {
  const response = await fetch(`/api/appointment/${appointmentId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })

  if (response.ok) {
    const appointment = (await response.json()) as Appointment
    return new SimplifiedAppointment(appointment)
  }

  throw Error("appointment service fetch failed")
}

export const useAppointmentQuery = ({
  appointmentId,
  token,
}: FetchAppointmentParams): UseQueryResult<SimplifiedAppointment> =>
  useQuery({
    queryKey: ["appointment", appointmentId],
    queryFn: async () => await fetchAppointment({ appointmentId, token }),
    enabled: !!token,
  })
